import { Box, Typography } from "@mui/material";
import type { Folder } from "certiblok-api-manager";
import { useTranslation } from "react-i18next";
import CertiblokIcon from "../icons/CertiblokIcon";

type Props = {
	folder: Folder;
	className?: string;
};

const DocumentsCount: React.FC<Props> = ({ folder, className }) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }} className={className}>
			<CertiblokIcon size={20} color="secondary" name={"paper_outline_02"} />
			<Typography variant="caption" className="line-clamp-2">
				<b>{folder.documentsCount ?? 0}</b> {t("folders.documentsCount", { count: folder.documentsCount ?? 0 })}
			</Typography>
		</Box>
	);
};

export default DocumentsCount;
